export const clientLogos = [
  {
    id: 1,
    name: "Anime Expo",
    logo: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/y6c6r7hi_Anime-Expo-Logo-Blog-Thumb.jpg"
  },
  {
    id: 2,
    name: "SXSW London",
    logo: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/iurdkeby_sxsw_london_logo-1536x1024.jpg"
  },
  {
    id: 3,
    name: "Sony Music",
    logo: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/ke99otn1_ogp.jpg"
  },
  {
    id: 4,
    name: "Riot Games",
    logo: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/wt5c1hyh_images%20%2810%29.png"
  },
  {
    id: 5,
    name: "Avex",
    logo: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/p1eqnim8_Avex_2017_%28Background%29.svg"
  },
  {
    id: 6,
    name: "hololive production",
    logo: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/vk0xudvk_download%20%284%29.jpeg"
  }
];

export const workItems = [
  {
    id: 1,
    title: "BE:FIRST World Tour 2025",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/cuzc3x3z_taiga%20photo.jpg",
    link: "https://www.billboard.com/music/concerts/befirst-first-world-tour-dates-2025-tickets-1235879207/"
  },
  {
    id: 2,
    title: "Franko - The Japanese Debut - SOLD OUT",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/qh53mr6w_FULL%20DATES%20%28SOLD%20OUT%20English%29.png",
    link: "https://www.instagram.com/p/DTO9uY7CYEo/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
  },
  {
    id: 3,
    title: "Mori Calliope 2nd Concert - Grimoire",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/hihhimh7_Grimoire_KV_HD_RGB.jpg",
    link: "https://hololive.hololivepro.com/en/events/grimoire/"
  },
  {
    id: 4,
    title: "Friday Night Kiss",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/1rtz29dj_Artcove%20-%20Friday%20Night%20Kiss%20-%20Chiaki%20Mayumura%2C%20jungwooseokr.png",
    link: "https://open.spotify.com/track/0sISTMuhVRsXcwdLUqkChL?si=900d9b2e44064cc5"
  },
  {
    id: 5,
    title: "Arjun Kanungo, Ren - Tell ME",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/232m073l_Art%20Cover%20Final%20_1.jpg",
    link: "https://open.spotify.com/track/2rOCJ6DFcSUd4HqiRZj7wP?si=ef39461d2fd64166"
  },
  {
    id: 6,
    title: "Daesung - JUMP",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/4jklklib_Dswave.jpeg",
    link: "https://open.spotify.com/track/5M0HHt2QWBgR74Xu4tonHI?si=96c396c983564090"
  },
  {
    id: 7,
    title: "BE:FIRST - Sailing (ONE PIECE Song)",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/b52vcu54_20241207-befirst-02.jpg",
    link: "https://open.spotify.com/track/3Bfv3Wg4HAhNFdVgWSfT0z?si=eccee886055143b9"
  },
  {
    id: 8,
    title: "SXSW London (Produced Japan Stage)",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/c3az87a2_SXSWLONDON.png",
    link: "https://www.sxswlondon.com/"
  },
  {
    id: 9,
    title: "riria. Sold out Show in Taipei 2026",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/1dvo53uj_faceless%20artist-%20Riria-Soldout-show%202026%20in%20taipei.jpg",
    link: "https://offtimemusic.kktix.cc/events/riria2026"
  },
  {
    id: 10,
    title: "Takanashi Kiara / Ninomae Ina'nis 1st Concert \"Drawn to Dawn\"",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/3e98nhne_251124_main-640x360.webp",
    link: "https://hololive.hololivepro.com/en/events/drawn-to-dawn/"
  },
  {
    id: 11,
    title: "[Eternal Return OST] Golden Willow (feat. Chiaki Mayumura)",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/gzokln6z_C0pYM7eGOzVNvgmOpr9QAwzKj6hrQ7Lz0jdeNbln.jpg",
    link: "https://www.youtube.com/watch?v=cZBgnOVr9j4"
  },
  {
    id: 12,
    title: "M1NU - 있잖아 (Feat. Chiaki Mayumura)",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/xf4jbsab_sddefault%20%281%29.jpg",
    link: "https://www.youtube.com/watch?v=lhVYedHbz_8"
  },
  {
    id: 13,
    title: "Arjun Kanungo - DANGER",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/oscwl748_101510184.avif",
    link: "https://www.youtube.com/watch?v=IF7Uit2Yb3g"
  },
  {
    id: 14,
    title: "Unspoken | Arjun Kanungo | NEXA Music",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/m8xo1l3y_maxresdefault%20%285%29.jpg",
    link: "https://www.youtube.com/watch?v=pRF5AteuXX4"
  },
  {
    id: 15,
    title: "Bunny Phyoe - နင်ပျော်ရင်",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/0e75fbvl_mqdefault.jpg",
    link: "https://www.youtube.com/watch?v=mipmHFaI2dU"
  },
  {
    id: 16,
    title: "Bunny Phyoe - Nin Pyaw Yin",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/hi8eq7qv_ab67616d00001e024a29c6fba03ee76a7f79cecb.jpeg",
    link: "https://open.spotify.com/track/3J69aOK5zcI6WbOe0ieLYk?si=07f83da1a6034b60"
  },
  {
    id: 17,
    title: "Naoto, Joey Montana - El Japonés",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/bcut9xzx_ab67616d0000b27336d3d9c361aa8b93bdd38f20.jpeg",
    link: "https://www.youtube.com/watch?v=GaQC4PcWGVw"
  },
  {
    id: 18,
    title: "Japan Show for Madhubanti Bagchi",
    image: "https://customer-assets.emergentagent.com/job_plus-creative-media/artifacts/9gjbksmp_2025-12-22T06%253A45%253A56.webp",
    link: "https://open.spotify.com/artist/4ojkMVHjuDZgDXSJy5qs2h?si=y0HcIhQqT2SQIZC10RL2Ag"
  }
];

export const companyInfo = {
  name: "going plus",
  tagline: "a music and entertainment company, established in Tokyo, specializing in music, live & touring, and creative ad campaign.",
  email: "kunii@goingplus.com"
};